"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ORMModelNames = void 0;
var ORMModelNames;

(function (ORMModelNames) {
  ORMModelNames["Address"] = "Address";
  ORMModelNames["Asset"] = "Asset";
  ORMModelNames["Bankruptcy"] = "Bankruptcy";
  ORMModelNames["Business"] = "Business";
  ORMModelNames["Case"] = "Case";
  ORMModelNames["Card"] = "Card";
  ORMModelNames["CaseImmigration"] = "CaseImmigration";
  ORMModelNames["Claim"] = "Claim";
  ORMModelNames["Contract"] = "Contract";
  ORMModelNames["District"] = "District";
  ORMModelNames["Exemption"] = "Exemption";
  ORMModelNames["Expense"] = "Expense";
  ORMModelNames["File"] = "File";
  ORMModelNames["Filer"] = "Filer";
  ORMModelNames["IdentificationNumber"] = "IdentificationNumber";
  ORMModelNames["IncomeMeansTest"] = "IncomeMeansTest";
  ORMModelNames["IncomeScheduleI"] = "IncomeScheduleI";
  ORMModelNames["IncomeSofa"] = "IncomeSofa";
  ORMModelNames["IncomeSource"] = "IncomeSource";
  ORMModelNames["IncomeSourceAnnualReport"] = "IncomeSourceAnnualReport";
  ORMModelNames["IncomeSourceMonthlyReport"] = "IncomeSourceMonthlyReport";
  ORMModelNames["LegalAction"] = "LegalAction";
  ORMModelNames["Party"] = "Party";
  ORMModelNames["Supplement"] = "Supplement";
  ORMModelNames["Transfer"] = "Transfer";
  ORMModelNames["TransferTransaction"] = "TransferTransaction";
})(ORMModelNames = exports.ORMModelNames || (exports.ORMModelNames = {}));